import { render } from "./IconTrolley.vue?vue&type=template&id=46a406c3"
import script from "./IconTrolley.vue?vue&type=script&lang=ts"
export * from "./IconTrolley.vue?vue&type=script&lang=ts"
script.render = render

export default script